import { usePriceFeed } from 'hooks/usePriceFeed'
import { currencyFormatter } from 'utils'
import { usePriceDirection } from 'hooks/usePriceDirection'
import { LvgAssetsDropdown } from './LvgAssetsDropdown'
import { LvgAssetHeaderCSS } from './LvgAssetHeaderCSS.styled'

export const LvgAssetHeader = ({ assetInfo, onSelect, noSelector }) => {
  const { priceFeed } = usePriceFeed(assetInfo.id)
  const { isUp } = usePriceDirection(priceFeed?.price)

  return (
    <LvgAssetHeaderCSS>
      <div className='game_header iw'>
        <div className={`current_price_display ${isUp ? 'up' : 'down'}`}>
          <div>
            <LvgAssetsDropdown assetInfo={assetInfo} onSelect={onSelect} noSelector={noSelector} />
          </div>
          <div className={`price_direction_icon ${isUp ? 'up' : 'down'}`} />
          <label>
            {currencyFormatter(priceFeed?.price, {
              decimalDigits: assetInfo.fiatDecimals,
              noCurrencySign: true,
              useLongNumber: true,
            })}
          </label>
        </div>
      </div>
    </LvgAssetHeaderCSS>
  )
}
